import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'The Ideal YOU',
  slug: 'the-ideal-you',
  category: 'The Ideal YOU',
  date: '2025-04-30',
  image: 'https://dpnelson.com/wp-content/uploads/2025/04/blogs-4.webp',
  excerpt: 'We play different roles in life: first, we are a son or daughter. Then, we might become a romantic partner, a parent, a boss, an employee. In each of these…',
  body: `We play different roles in life: first, we are a son or daughter. Then, we might become a romantic partner, a parent, a boss, an employee. In each of these roles, we have slightly different faces, different tasks and responsibilities.

For any role, visualize the ideal person you would want to be in that role.

For example, if you could build the perfect parent, how would that parent respond to your children? For the sake of the exercise, take yourself out of the picture. Put a placeholder person.

If you could build the perfect life partner, what would you want that person to be for your spouse/life partner?

Be as specific as you can. You now have a template for the role. This gives you something substantial to aim at.

Be THAT person. Find a way to live into it.`,
}

export default post
